// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick an existing delivery address — new addresses are not supported for this customer`)
};

const en_us2_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick an existing delivery address — new addresses are not supported for this customer`)
};

const de_de2_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte eine bestehende Lieferadresse auswählen — neue Adressen werden für diesen Kunden nicht unterstützt`)
};

const en_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick an existing delivery address — new addresses are not supported for this customer`)
};

const de_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte eine bestehende Lieferadresse auswählen — neue Adressen werden für diesen Kunden nicht unterstützt`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1", locale)
	if (locale === "en-GB") return en_gb2_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1(inputs)
	if (locale === "en-US") return en_us2_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1(inputs)
	if (locale === "de-DE") return de_de2_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1(inputs)
	if (locale === "en") return en_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1(inputs)
	return de_pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1(inputs)
};
export { pick_an_existing_delivery_address___new_addresses_are_not_supported_for_this_customer1 as "Pick an existing delivery address — new addresses are not supported for this customer" }